import PurchaseHistory from './PurchaseHistory';

export default PurchaseHistory;
